import { useViewDataset } from '@/hooks/useViewDataset.ts';
import DataViewerContainer from '@/layouts/DataViewer/DataViewerContainer.tsx';
import { Box } from '@mantine/core';

const DataViewerSidebar = () => {
  const { datasetId, setDatasetId } = useViewDataset();

  return (
    <Box
      pos="absolute"
      style={{
        inset: 0,
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
        overflow: 'hidden',
      }}
      w="100%"
      h="100%"
    >
      <DataViewerContainer datasetId={datasetId} setDatasetId={setDatasetId} />
    </Box>
  );
};

export default DataViewerSidebar;
